import { isNative } from './platform';

const stripBase64Prefix = (dataUrl) => {
  const comma = dataUrl.indexOf(',');
  return comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
};

async function saveImageNative({ dataUrl, filename }) {
  const { Filesystem, Directory } = await import('@capacitor/filesystem');
  const { Share } = await import('@capacitor/share');

  const base64 = stripBase64Prefix(dataUrl);
  const written = await Filesystem.writeFile({
    path: filename,
    data: base64,
    directory: Directory.Cache,
  });

  try {
    await Share.share({
      title: filename,
      files: [written.uri],
    });
    return { cancelled: false };
  } catch (err) {
    if (err && err.name === 'AbortError') return { cancelled: true };
    throw err;
  }
}

function saveImageWeb({ dataUrl, filename }) {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return { cancelled: false };
}

export async function saveImage({ dataUrl, filename }) {
  if (isNative()) {
    return saveImageNative({ dataUrl, filename });
  }
  return saveImageWeb({ dataUrl, filename });
}
